import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import * as CKEDITOR from '../../vendor/ckeditor5/build/ckeditor.js';

@Component({
    selector: 'formly-field-textarea',
    template: `
        <ckeditor
                [editor]="simpleEditor"
                [formControl]="formControl"
                [class.is-invalid]="showError"
                [formlyAttributes]="field"></ckeditor>
    `,
})
export class FormlyFieldTextareaComponent extends FieldType
{
    simpleEditor = CKEDITOR.SimpleEditor;

    get type() {
        return this.to.type || 'textarea';
    }
}
